import React from "react";
import { Platform } from "react-native";
import { WebModal } from "./WebModal";

export function withWebModal<T extends React.ComponentType<any>>(
  Component: T,
  dismissable?: boolean,
  webModalProps?: Omit<
    React.ComponentProps<typeof WebModal>,
    "children" | "dismissable"
  >
) {
  if (Platform.OS === "web") {
    return function InnerWebModal(props: any) {
      return (
        <WebModal dismissable={dismissable} {...webModalProps}>
          <Component {...(props as any)} />
        </WebModal>
      );
    };
  }
  return Component as T;
}
